import { ButtonPrimary, DescriptionBody, TitleBody } from "../../../../common";
import { urlsPages } from "../../../../common/urls/urls-pages";
import { QuotaUpgradeCopy, QuotaUpgradeWrapper } from "./session-quota-upgrade.style";

type Props = {
    executionsUsed: number;
    executionsLimit: number;
};

export const SessionQuotaUpgrade = ({ executionsUsed, executionsLimit }: Props) => {
    return (
        <QuotaUpgradeWrapper>
            <TitleBody>Assine o Pro</TitleBody>
            <DescriptionBody>
                Você usou {executionsUsed} de {executionsLimit} sessões deste drill nos últimos 30 dias.
            </DescriptionBody>
            <QuotaUpgradeCopy>
                Faça upgrade para treinos ilimitados em todos os drills.
            </QuotaUpgradeCopy>
            <ButtonPrimary goToPage={`${urlsPages.home}#precos`} width="100%" margintop="24px">
                Assinar o Pro
            </ButtonPrimary>
        </QuotaUpgradeWrapper>
    );
};
